<template>
  <div>
    <div class="header-logo">
      <div class="logo-wrap">
        <img class="logo" src="@img/logo.png">
      </div>
      <div class="title-wrap">
        <div>
          <div class="title">{{ name }}</div>
          <div class="sub-title">{{ name_Int }}</div>
        </div>
        <div class="info">（监管端）</div>
      </div>
    </div>
    <div class="header-user">
      <el-dropdown placement="bottom" @command="handleUserDropdownCommand">
        <span class="el-dropdown-link header-dropdown-link">
          <div style="display:flex;align-items:center">
            <i style="font-size: 18px;margin-right:5px;" class="el-icon-user"></i>
            {{ userInfo.username }}
            <i style="font-size: 12px;margin-left:5px" class="el-icon-caret-bottom"></i>
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="OperationManual">操作文档</el-dropdown-item>
          <el-dropdown-item command="AccountInfo">账号信息</el-dropdown-item>
          <el-dropdown-item command="ChangePassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="Logout" divided>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div>
      <div class="nav-bar">
        <div :key="item.title" v-for="(item, index) in routesArr" @click="itemClick(index, item)" :class="currentIndex.indexOf(item.path) > -1 ? 'current-item' : ''" class="menu-item">
          <i v-if="item.meta.icon" style="font-size: 18px" :class="item.meta.icon"></i>
          <img v-else-if="item.meta.img" :src="item.meta.img" style="height:20px;">
          <span style="white-space: nowrap;font-size: 12px">{{item.meta.title}}</span>
        </div>
      </div>
    </div>
    <PasswordForm ref="passwordForm"></PasswordForm>
    <InfoForm ref="InfoForm"></InfoForm>
    <el-dialog
      append-to-body
      title="操作文档"
      :visible.sync="showEchartDialog"
      width="85%">
      <Echart ref="Echart"></Echart>
    </el-dialog>
  </div>
</template>


<script>
  import PasswordForm from './PasswordForm'
  import InfoForm from './InfoForm'
  import * as types from '@/vuex/types'
  import Echart from '@/views/systemData/systemData.vue'
  export default {
    components: {
      PasswordForm,
      InfoForm,
      Echart,
    },
    data () {
      return {
        userInfo: {company: {}},
        currentIndex: '',
        name: '泉州市安全生产标准化智慧管理平台',
        name_Int: 'Quanzhou safety standardization intelligent management platform',
        showEchartDialog: false,
      }
    },
    computed: {
      routesArr () {
        let routes = this.$store.getters['permission/routers']
        this.currentIndex = this.$route.path
        return routes.filter(item => {
          return item.isHead
        }).sort((a, b) => {
          return b.index - a.index
        })
      }
    },
    mounted () {
      let hostname = window.location.hostname
      let port = window.location.port
      this.name = '泉州市安全生产标准化智慧管理平台'
      this.name_Int = 'Quanzhou safety standardization intelligent management platform'
      // if(hostname == 'localhost' || hostname == '222.77.0.146'){
      //   if(port == 9010){
      //     this.name = '丰泽区安全生产标准化智慧管理平台'
      //     this.name_Int = 'Fengze safety standardization intelligent management platform'
      //   }else if(port == 9014) {
      //     this.name = '南安市九小场所安全生产标准化管理平台'
      //     this.name_Int = "Nan'an nine small place safety standardization management platform"
      //   }else{
      //     this.name = '泉州市安全生产标准化智慧管理平台'
      //     this.name_Int = 'Quanzhou safety standardization intelligent management platform'
      //   }
      // }else{
      //   this.name = '安全生产标准化智慧管理平台'
      //   this.name_Int = 'Safety standardization intelligent management platform'
      // }

      let userInfo = this.$store.getters.userInfo
      this.userInfo = userInfo
    },
    methods: {
      itemClick (index, item) {
        if (item.name == 'dataV') {
          this.goEchart()
        } else {
          this.$router.push(item.path)
        }
      },
      // 右上角菜单点击响应
      handleUserDropdownCommand (command) {
        switch(command){
          case 'ChangePassword': // 修改密码
            this.$refs['passwordForm'].showForm();
            break;
          case 'AccountInfo': // 账号信息
            this.$refs['InfoForm'].showForm();
            break;
          case 'Logout': // 退出登录
            this.$store.commit(types.LOGOUT);
            this.$router.replace({ name: 'login' });
            break;
          case 'OperationManual': // 操作文档
            this.showEchartDialog = true
            break;
        }
      },
      goCompanyGraph () {
        window.open(`${this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL}/companyUnit.html?id=${this.$store.getters.companyId}`)
      },
      goEchart () {
        window.open(`${this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL}/#/dvOne?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c`)
        // window.open(`http://dev-risk-qz-datav.zyrcsoft.com/#/dvOne?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c`)
      }
    }
  }
</script>

<style scoped>
  .header-logo {
    display: flex;
    margin: 16px 0 0 0;
    color: #fff;
    float: left;
  }
  .logo-wrap .logo {
    margin-right: 10px;
    width: 40px;
    height: 42px;
  }
  .title-wrap {
    display: flex;
    align-items: flex-end;
  }
  .title-wrap .title {
    font-size: 26px;
    font-weight: bold;
    line-height: 1;
  }
  .title-wrap .sub-title {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1;
  }
  .title-wrap .info {
    font-size: 18px;
    font-weight: 500;
    line-height: 1;
  }
  .header-goEchart {
    margin: 20px 30px 0 0;
    /* color: #fff; */
    float: right;
    cursor: pointer;
    /* border-left: 1px solid #ccc;
    border-right: 1px solid #ccc; */
  }
  .header-goEchart:hover {
    /* color: rgba(255, 255, 255, .8); */
  }
  .header-user {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 20px;
    padding: 0 30px;
    height: 70px;
    color: #CBCFD4;
    float: right;
  }
  .header-user::before {
    content: '';
    position: absolute;
    left: 0;
    width: 1px;
    height: 27px;
    background: #FFFFFF;
  }
  .header-dropdown-link {
    cursor: pointer;
    color: #fff;
  }
  .header-dropdown-link:hover {
    color: #fff;
  }
  .header-dropdown-link div {
    height: 30px;
  }
  .nav-bar {
    height: 70px;
    display: flex;
    align-items: center;
    color: #fff;
    padding-left: 15px;
    /* float: right; */
    flex-direction: row-reverse;
    padding-right: 20px;
  }
  .current-item {
    color: #fff;
    background: #3C87FB;
    border-bottom: 4px solid #FFA58F;
  }
  .menu-item {
    cursor: pointer;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    height: 70px;
    background-color: #5190fb;
  }
</style>



// WEBPACK FOOTER //
// src/components/frame/HeadBar.vue